export type ThemePreference = "light" | "dark" | "system";

export const THEME_STORAGE_KEY = "tailorbook:theme";

export function normalizeThemePreference(value: unknown): ThemePreference {
  return value === "light" || value === "dark" || value === "system" ? value : "system";
}

export function getStoredThemePreference(): ThemePreference {
  try {
    return normalizeThemePreference(localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return "system";
  }
}

export function resolveTheme(preference: ThemePreference, prefersDark = typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia("(prefers-color-scheme: dark)").matches : false): "light" | "dark" {
  return preference === "system" ? (prefersDark ? "dark" : "light") : preference;
}

export function applyTheme(preference: ThemePreference): "light" | "dark" {
  const resolved = resolveTheme(preference);
  document.documentElement.classList.toggle("dark", resolved === "dark");
  document.documentElement.classList.toggle("light", resolved === "light");
  document.documentElement.style.colorScheme = resolved;
  return resolved;
}

export function loadThemePreference(remoteSettings?: Record<string, unknown> | null): ThemePreference {
  const remoteTheme = remoteSettings?.theme;
  if (remoteTheme === "light" || remoteTheme === "dark" || remoteTheme === "system") return remoteTheme;
  return getStoredThemePreference();
}

export function saveThemePreference(preference: ThemePreference) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    // Theme still applies for the current session when storage is unavailable.
  }
  applyTheme(preference);
  window.dispatchEvent(new CustomEvent("tailorbook:theme-change", { detail: preference }));
}
